import {
    useBuscarTarjetasDashboard
} from "../../Scripts/Services/banco-dashboard-service.js";
import parse from 'html-react-parser';

import { SelectButton, Calendar, Dropdown, addLocale, Skeleton, Message } from 'primereact';
import React, {useEffect, useState} from 'react';
import {
  Tarjetas,
  TarjetasMultiple,
  TarjetasMultipleSkeleton,
  TarjetasSkeleton
} from "../../../Commons/Scripts/Componentes/Dashboards/Tarjetas";
import {LOCALE_ES_DATEPICKER, PERIODOS_DDL as periodos, PERIODOS_ACTUAL as actual, PERIODOS_ANTERIOR as anterior} from "../../../Commons/Scripts/Utils";


export const TarjetasBanco = () => {
  const simboloMoneda = window.monedaPredeterminada;
  const [where, setWhere] = React.useState({
    where: {
      periodo: "mensual",
      fechaInicio: null,
      fechaFin: null,
      esFecha: false,
    },
  });

  const { data, error } = useBuscarTarjetasDashboard(where);

  const [periodo, setPeriodo] = React.useState(1);
  
  const [value, setValue] = React.useState(3);
  const [periodosPredifinidos, setPeriodosPredifinidos] = React.useState([]);

  function handleChange(value) {
    setValue(value);
    setCargando(true);
    switch (value) {
      case 1:
        setWhere({
          where: {
            periodo: "diario",
            fechaInicio: null,
            fechaFin: null,
            esFecha: false,
          },
        });
        break;
      case 2:
        setWhere({
          where: {
            periodo: "semanal",
            fechaInicio: null,
            fechaFin: null,
            esFecha: false,
          },
        });
        break;
      case 3:
        setWhere({
          where: {
            periodo: "mensual",
            fechaInicio: null,
            fechaFin: null,
            esFecha: false,
          },
        });
        break;
      case 4:
        setWhere({
          where: {
            periodo: "trimestral",
            fechaInicio: null,
            fechaFin: null,
            esFecha: false,
          },
        });
        break;
      case 5:
        setWhere({
          where: {
            periodo: "anual",
            fechaInicio: null,
            fechaFin: null,
            esFecha: false,
          },
        });
        break;
      case 6:
        setWhere({
          where: {
            periodo: "ayer",
            fechaInicio: null,
            fechaFin: null,
            esFecha: false,
          },
        });
        break;
      case 7:
        setWhere({
          where: {
            periodo: "semana anterior",
            fechaInicio: null,
            fechaFin: null,
            esFecha: false,
          },
        });
        break;
      case 8:
        setWhere({
          where: {
            periodo: "mes anterior",
            fechaInicio: null,
            fechaFin: null,
            esFecha: false,
          },
        });
        break;
      case 9:
        setWhere({
          where: {
            periodo: "trimestre anterior",
            fechaInicio: null,
            fechaFin: null,
            esFecha: false,
          },
        });
        break;
      case 10:
        setWhere({
          where: {
            periodo: "ano anterior",
            fechaInicio: null,
            fechaFin: null,
            esFecha: false,
          },
        });
        break;
    }
  }

  const [dates, setDates] = React.useState(null);
  let today = new Date();
  const [verRangoDeFechas, setVerRangoDeFechas] = React.useState(false);

  const [cargando, setCargando] = React.useState(true);
  const [tarjeta, setTarjeta] = React.useState(null);
  function setFechas() {
    setWhere({
      where: {
        periodo: "",
        fechaInicio: formatDate(dates[0]),
        fechaFin: formatDate(dates[1]),
        esFecha: true,
      },
    });
    setCargando(true);
    setValue(null);
  }
  function formatDate(date) {
    var date = new Date(date);
    var day = date.getDate();
    var month = date.getMonth() + 1;
    var year = date.getFullYear();
    return day + "/" + month + "/" + year;
  }
  addLocale("es", LOCALE_ES_DATEPICKER);

  React.useEffect(() => {
    if (dates !== null && dates[1] !== null) {
      setFechas();
    }
  }, [dates]);

  React.useEffect(() => {
    if (data) {
      setTarjeta(data);
      setCargando(false);
    }
  }, [data]);

  React.useEffect(() => {
    if (periodo == 1) {
      setPeriodosPredifinidos(actual);
      setVerRangoDeFechas(false);
    } else if (periodo == 2) {
      setPeriodosPredifinidos(anterior);
      setVerRangoDeFechas(false);
    } else {
      setVerRangoDeFechas(true);
    }
  }, [periodo]);
  return (
    <React.Fragment>
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "10px",
            padding: "12px",
            flexWrap: "wrap",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div style={{ width: "20%", marginBottom: "5px" }}>
            <Dropdown
              value={periodo}
              onChange={(e) => setPeriodo(e.value)}
              options={periodos}
              optionLabel="name"
            />
          </div>

          {verRangoDeFechas ? (
            <div>
              <Calendar
                maxDate={today}
                placeholder="Rango de Fechas"
                dateFormat="dd/mm/yy"
                value={dates}
                selectionMode="range"
                locale="es"
                onChange={(e) => setDates(e.value)}
              />
            </div>
          ) : (
            <SelectButton
              value={value}
              onChange={(e) => handleChange(e.value)}
              optionLabel="name"
              options={periodosPredifinidos}
            />
          )}
        </div>
      </div>
      <div>
        {error && (
          <Message
            severity="warn"
            text={error?.Mensaje}
            style={{ width: "100%", marginBottom: "10px" }}
          />
        )}
      </div>
      <div>
        {cargando ? (
          <>
            <div className="card_row">
              <TarjetasSkeleton />
              <TarjetasSkeleton />
              <TarjetasSkeleton />
              <TarjetasSkeleton />

            </div>
          </>
        ) : (
          <>
            <Tarjetas
              Tarjetas={tarjeta.Tarjetas}
              SimboloMoneda={simboloMoneda}
            />
          </>
        )}
        <div id="chart_holder_tarjetas" class="card_row"></div>
      </div>
    </React.Fragment>
  );
};